import { render } from "./OapCarouselControls.vue?vue&type=template&id=1e2d8fac"
import script from "./OapCarouselControls.vue?vue&type=script&lang=js"
export * from "./OapCarouselControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__